import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface AnexoVisualizarData {
  blob: Blob;
  nome: string;
}

@Component({
  selector: 'app-anexo-visualizar-dialog',
  templateUrl: './anexo-visualizar-dialog.component.html',
  styleUrls: ['./anexo-visualizar-dialog.component.scss'],
})
export class AnexoVisualizarDialogComponent implements OnDestroy {

  urlSegura: SafeResourceUrl | null = null;
  urlObjeto = '';
  ehImagem = false;
  ehPdf = false;

  constructor(
    private dialogRef: MatDialogRef<AnexoVisualizarDialogComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: AnexoVisualizarData,
  ) {
    this.urlObjeto = URL.createObjectURL(data.blob);
    this.urlSegura = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlObjeto);
    const mime = (data.blob.type || '').toLowerCase();
    const nome = (data.nome || '').toLowerCase();
    this.ehImagem = mime.startsWith('image/') || /\.(png|jpe?g|gif|webp|bmp)$/.test(nome);
    this.ehPdf = mime.includes('pdf') || nome.endsWith('.pdf');
  }

  ngOnDestroy(): void {
    if (this.urlObjeto) {
      URL.revokeObjectURL(this.urlObjeto);
    }
  }

  baixar(): void {
    const a = document.createElement('a');
    a.href = this.urlObjeto;
    a.download = this.data.nome || 'anexo';
    a.click();
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
